export const queryKeys = {
  getCampaigns: "getCampaigns",
  getOrganizationCampaignLookups: "getOrganizationCampaignLookups",
  getOrganizationCampaign: "getOrganizationCampaign",
  getCampaignContributionReport: "getCampaignContributionReport",
  getOrganizationReportCampaignLookups: "getOrganizationReportCampaignLookups",
  searchOrganizationCampaign: "searchOrganizationCampaign",
  sendEmployeeMail: "sendEmployeeMail",
  searchDonorCampaign: "searchDonorCampaign",
};
